<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <div class="col-sm-12 text-right">
                            <button class="btn btn-danger mr-5" type="button" @click="deletesalesdataModal">Delete Data</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                        <label style="margin-left: 30px;">Geographic Area</label><br>
                                        <!-- <select v-model="salesdata.region" required name="region" class="form-control" @change="getSite">
                                            <option disabled>Select G.A</option>
                                                <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select> -->
                                        <label style="margin-left: 35px;font-size: 20px;" > {{salesdata.regionName}}</label>
                                    </validate>
                                    <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">G.A is a required field</div>
                                    </field-messages>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.site)">
                                        <label style="margin-left: 30px;">Location</label><br>
                                        <!-- <select v-model="salesdata.site" required name="site" class="form-control" @change="getDispenserCount">
                                            <option selected disabled > Select Location</option>
                                                <option v-for="(item,index) in site_list" :key="index" v-bind:value="item._id" v-bind:count="item.dispenserCount">
                                                {{item.siteName}}
                                            </option>
                                        </select> -->
                                        <label style="margin-left: 30px;font-size: 20px;" > {{salesdata.siteSiteName}}</label>
                                    </validate>
                                    <field-messages name="site" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Location is a required field</div>
                                    </field-messages>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportedDate)">
                                        <label>Report Date</label>
                                        <date-picker  id="reportedDate" required v-model="salesdata.reportedDate" lang="en" name="reportedDate" input-class="form-control" width="100%" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="reportedDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Date is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <!-- <div class="col-sm-3">
                                    <label>Location</label>
                                    <select class="form-control" @change="enableLocation">
                                        <option>Select</option>
                                        <option value ="Car">Car</option>
                                        <option value="Bus">Bus</option>
                                    </select>
                                </div> -->
                            </div>
                            <div class="col-sm-12">
                                <legend class="col-md-12">Sales Data</legend>
                            </div>
                            <div id="nozzlesNumber" >
                                <div class="col-sm-12" id="dispenser"  v-for="(dispenser_number,i) in total_dispancer" >
                                    <div class="col-sm-12">
                                        <br>
                                        <label > Dispenser {{dispenser_number}} </label>
                                        <br>
                                    </div>
                                    <div class="col-sm-12">
                                    <div class="col-sm-2">                                        
                                        <label>Nozzle A Opening</label>
                                        <input type="number" ref="nozzleAOpening" class="form-control" required v-model="salesdata.dispenserData[i].nozzleA.nozzleAOpening" @change="compareValue($event,i,'nozzleAOpening')">
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Nozzle A Closing</label>
                                        <input type="number" ref="nozzleAClosing" class="form-control" required v-model="salesdata.dispenserData[i].nozzleA.nozzleAClosing" @change="compareValue($event,i,'nozzleAClosing')">
                                        
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Meter Jump A</label>
                                        <input type="number" ref="nozzleAMeterJump" class="form-control" required v-model="salesdata.dispenserData[i].nozzleA.nozzleAMeterJump">                                       
                                    </div>
                                    <div class="col-sm-2">
                                        <label>Nozzle B Opening</label>
                                        <input type="number" ref="nozzleBOpening" class="form-control" required v-model="salesdata.dispenserData[i].nozzleB.nozzleBOpening" @change="compareValue($event,i,'nozzleBOpening')">                                    
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Nozzles B closing</label>
                                        <input type="number" ref="nozzleBClosing" class="form-control" required v-model="salesdata.dispenserData[i].nozzleB.nozzleBClosing" @change="compareValue($event,i,'nozzleBClosing')">                                        
                                    </div>
                                    <div class="col-sm-2 ">                                        
                                        <label>Meter Jump B</label>
                                        <input type="number" ref="nozzleBMeterJump" class="form-control" required v-model="salesdata.dispenserData[i].nozzleB.nozzleBMeterJump">                                       
                                    </div>
                                </div>
                                </div>
                                <!-- <div class="col-sm-12" id="busDispenser"  v-for="(k,i) in total_dispancer" v-if="this.value == bus" >
                                    <div class="col-sm-2">                                        
                                        <label>Dispenser A Opening</label>
                                        <input type="number" name="name" class="form-control" required v-model="k.dispenser_A_opening">
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Dispenser A Closing</label>
                                        <input type="number" name="name" class="form-control" required v-model="k.dispenser_A_closing">
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Meter Jump A</label>
                                        <input type="number" name="name" class="form-control" required v-model="k.meterJumpA">                                       
                                    </div>
                                </div> 
                                <br><br><br>-->
                            </div>
                            <br><br>
                            <div class="col-sm-12">
                                <div class="col-sm-10"></div>
                                <div class="col-sm-2 text-left">
                                    <br>
                                    <label> Total Quantity</label>
                                    <input type="number" name="totalValue" class="form-control" v-model="salesdata.totalValue"> 
                                </div> 
                            </div>
                        </vue-form>
                        <div></div><br><br>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'salesdata' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                                <button class="mr-5 btn gradientbt2" style="background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));color: white;" type="submit" @click="updatesalesdata"  >Update Sales Status</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import { formService, eventBus , salesdataService} from '../../../services'
import { EVENTS } from '../../../config'
import swal from 'sweetalert2'
export default {
    name: 'SalesdataDetails',
    data () {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list :{},
            site_list :{},
            salesdata :{
                status : 'active',
                dispenserData : {
                    nozzle_A_opening : [],
                    nozzle_A_closing : [],
                    meterJumpA : [],
                    nozzle_B_opening : [],
                    nozzle_B_closing : [],
                    meterJumpB : [],
                },
            }, 
            total_dispancer : '',
            totalDispenser : '',
            

        }
    },
    mounted () {
        this.getRegion()
        // this.getSiteName()
        this.getsalesdata()
    },
    methods :{
        fieldClassName: formService.fieldClassName,
        compareValue(e,i,name){
            // console.log("iiiii",i)
            // console.log("hiiiii" , 
            // this.$refs['nozzleAOpening'][i].value, this.$refs['nozzleAClosing'][i].value,
            // Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value))
            if(name == 'nozzleAClosing' ){
                console.log("hello")
               if(Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)){
                   console.log("Please enter Closing value greater than Opening value")
                    this.$snotify.error("Please enter value greater than Opening value")
                    this.salesdata.dispenserData[i].nozzleA.nozzleAClosing = this.salesdata.dispenserData[i].nozzleA.nozzleAOpening
               }
            }
            if(name == 'nozzleBClosing' ){
                console.log("hello" , this.$refs['nozzleAClosing'][i].value)
               if(Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)){
                   this.$snotify.error("Please enter Closing value greater than Opening value")
                   this.salesdata.dispenserData[i].nozzleB.nozzleBClosing = this.salesdata.dispenserData[i].nozzleB.nozzleBOpening
               }
            }
            if(name == 'nozzleAOpening' ){
                console.log("hello")
               if(Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)){
                   console.log("Please enter Opening value less than Closing value")
                    this.$snotify.error("Please enter value greater than Opening value")
                    this.salesdata.dispenserData[i].nozzleA.nozzleAOpening = 0
               }
            }
            if(name == 'nozzleBOpening' ){
               if(Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)){
                   this.$snotify.error("Please enter Opening value less than Closing value")
                   this.salesdata.dispenserData[i].nozzleB.nozzleBOpening =0
               }
            }
        },
        getRegion() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                       
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getSiteName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.region = this.salesdata.region;
            let sitelist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    
                    this.loading  = false;
                    if (res.data.docs) {
                        sitelist =  res.data.docs;
                       
                    }
                    console.log("res",res)
                    this.site_list = sitelist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })
        },
        getSite(e){
            this.salesdata.dispenserData = {
                nozzle_A_opening : [],
                nozzle_A_closing : [],
                meterJumpA : [],
                nozzle_B_opening : [],
                nozzle_B_closing : [],
                meterJumpB : [],
            };
            this.salesdata.totalValue = '';  
            const params  = {}
            params.$limit = 0;
            params.region = e.target.value;
            let sitelist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    
                    this.loading  = false;
                    if (res.data.docs) {
                        sitelist =  res.data.docs;
                       
                    }
                    console.log("res",res)
                    this.site_list = sitelist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })
        },
        getDispenserCount(e){
            this.count =  e.target.options[e.target.selectedIndex].getAttribute('count');
            console.log("hhdhfj",this.count)
            
            this.total_dispancer = parseInt(this.count)
            console.log ("total_dispenser",this.total_dispancer)
            this.totalDispenser = this.total_dispancer - 1
            console.log("totalDispenser",this.totalDispenser)
            
        },
        getsalesdata () {
            return this.$salesdataDataRepository.find(this.$route.params._id)
            .then((response) => {
                console.log("saleeeeee",response)
                this.total_dispancer = response.data.dispenserData.length;
                console.log("total_dispancerrrrrrrrr",this.total_dispancer)
                this.salesdata = response.data;
                this.getSiteName()
            })
            .catch((error) => {
                this.$snotify.error('Sales Data detail failed', 'Error!')
            })
        },
        updatesalesdata () {
            this.loading = true;
            return salesdataService.updatesalesdata(this.salesdata)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Data updated!', 'Success!')
                this.$router.push('/sales_settings')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Data update failed!Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'Data update is failed.Please try again!'
                }
            })
        },
        deletesalesdataModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Data!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deletesalesdata()
                }
            })
        },
        deletesalesdata () {
            this.loading = true
            return this.$salesdataDataRepository.deleteOne(this.salesdata._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Data has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/sales_settings')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete data failed', 'Error!')
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        },
}
}
</script>

<style scoped>
.required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
.gradientbt2{
    background: #0F6940;
        color: white
    }


// WEBPACK FOOTER //
// SalesdataDetails.vue?1c6137ac